// src/store/index.ts
import { configureStore } from '@reduxjs/toolkit';
import billingReducer from './features/billing/billingSlice';
import { ticketsReducer } from './features/tickets/ticketsSlice';
import { ticketsListenerMiddleware } from './features/tickets/ticketsListeners';
import { projectsReducer } from './features/projects/projectsSlice';
import { ticketPortalReducer } from './features/ticketPortal/ticketPortalSlice';

export const store = configureStore({
  reducer: {
    billing: billingReducer,
    tickets: ticketsReducer,
    projects: projectsReducer,
    ticketPortal: ticketPortalReducer,
  },
  middleware: (getDefault) =>
    getDefault().concat(ticketsListenerMiddleware.middleware), 
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
